import React, { useEffect } from 'react';

export const AdminShell = ({ title, children, wide = false }) => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <div className="min-h-screen bg-bone-light flex items-start justify-center px-4 py-12" data-testid="admin-shell">
      <div className={`w-full ${wide ? 'max-w-6xl' : 'max-w-md'}`}>
        <div className="text-center mb-8">
          <div className="text-kombu-green font-serif font-semibold tracking-[0.3em] text-2xl">BULLISH</div>
          <div className="text-[10px] tracking-[0.4em] text-moss-green">TAX &amp; ADVISORY</div>
          <div className="text-sm text-gray-500 mt-1">{title}</div>
        </div>
        {children}
      </div>
    </div>
  );
};
